<style scoped>
    @import url("../../../styles/smartControl/cardEditXilema.scss");
</style>

<template>
    <div class="box_cardEditXilema mt-2">

        <!-- Caixa de diálogo aberta após input de atualização -->
        <v-dialog v-model="flagDialog" max-width="250px">
            <div v-if="flagDialog && !flagLoading">
                <DialogMSG 
                v-if="flagDialog" 
                :msgFromFather="msgFromFather"
                @fromDialogMsg="flagDialog = false" 
                />
            </div>
        </v-dialog>

        <!-- LOADING -->
        <div v-if="flagLoading" class="mb-16 mt-16"
        :style="{'display':'flex','width':'100%','align-items':'center','justify-content':'center'}">
            <v-progress-circular 
                color="black"
                size="64"
                indeterminate
            ></v-progress-circular>
        </div>

        <div class="linhaZero" v-if="!flagDialog && !flagLoading">
            <v-chip v-if="controller.t == null" class="ml-1" size="x-small" color="white">
                Atuador sem nome (!)
            </v-chip>
            <v-chip v-else class="ml-1" size="x-small" color="white">
                {{ controller.t }}
            </v-chip>
            <v-icon class="ml-1" size="32">mdi-pen</v-icon>
        </div>

        <div class="linhaUm mt-4" v-if="!flagDialog && !flagLoading">

            <div class="colUm">
                <div class="elSelect">
                    <v-autocomplete
                    v-model="currentProgram"
                    :items="liPrograms"
                    color="rgb(247,215,46)"
                    class="w-100"
                    variant="plain"
                    bg-color="transparent"
                    @update:modelValue="changeInfo()"
                    placeholder="nº do programa a ser acionado"
                    ></v-autocomplete>
                </div>
            </div>
        </div>

        <v-btn v-if="flagBtnEnd && !flagDialog && !flagLoading"
        @click="sendInfo()"
        :style="{'color':'green'}"
        >
            <v-icon class="mr-1" size="16">mdi-pump</v-icon>
            <span class="txt_btn_irrig">Atualizar</span>
        </v-btn>

    </div>
</template>

<script>
import axios from 'axios'
import DialogMSG from './DialogMSG.vue'

export default {
    props: ['controller','tok'],

    components:{DialogMSG},

    data() {
        return {
            liPrograms:[],
            currentProgram:null,
            flagBtnEnd:false,

            // estrutural local
            flagLoading:false,
            flagDialog:false,
        }
    },

    methods: {
        changeInfo() {
            // SE houve mudança de pino/programa então atualizar.
            //console.log('this.currentProgram: ',this.currentProgram)
            this.flagBtnEnd =
                Number.isInteger(this.currentProgram) &&
                this.currentProgram >= 0 &&
                this.currentProgram <= 98 &&
                this.currentProgram !== Number(this.controller.p)
        },

        async sendInfo() {
            //console.log('[from props] controller: ',this.controller)
            //console.log('currentProgram: ',this.currentProgram)
            this.flagLoading = true

            let local_list = structuredClone(this.controller.main) // lista atuadores
            //let local_list = JSON.parse( JSON.stringify(this.controller.main) )
            let local_item = local_list[this.controller.c] // item da lista atuadores em edição
            for (const param of local_item.params) {
                if (param.titulo == this.controller.t) {
                    param.pino = String(this.currentProgram)
                }
            }
            //console.log('local_list: ',local_list)

            const headers = {
                'Authorization': `Bearer ${this.$store.state.tox}`,
                'Xilema-Auth': `Bearer ${this.tok}`, // rcv from props
                'Content-Type': 'application/json'
            }
            let rotaBranch = '/xadmxeditbyinfokeyx'
            let params = {
                "api_client":this.$store.state.emailCliente,
                "coll":this.$store.state.sistemaSC,
                "name_key":"identifier",
                "key_value":"ia_agent_unit",
                "target_key":"atuadores", // <-- key of a list
                "edited_element":local_list // <-- edited list
            }
            const rota = this.$store.state.pathAxiosBASE + rotaBranch
            const res = await axios.post(rota, params, {headers})
            //console.log(res.data.result)
            //console.log('end 1')
            this.flagLoading = false
            //console.log('end 2')
            const rcv = res.data.result ?? res.data
            this.flagDialog = true
            //console.log('rcv: ',rcv)
            if (rcv.ok) {
                this.msgFromFather = 'Atualizado.'
                this.flagBtnEnd = false // reset
            }
            else {
                this.msgFromFather = 'Não foi possível atualizar. Tente novamente mais tarde.'
            }
        },
    },

    created() {
        this.currentProgram = structuredClone(this.controller.p)
        for (let i = 0; i <= 98; i++) {
            this.liPrograms.push(i)
        }
    },
}
</script>
